import React from "react";

import modStyl from './block-a.module.scss'
import Cell from "../cell";
import { ChartDataResult } from "../../../../../../../services/data/dashboard";
import LineChart from "../line-chart";

type Props = {
  dataSource: ChartDataResult['questionTime']
}

const BlockI: React.FC<Props> = ({ dataSource })=> {
  return (
    <div className={modStyl.a}>
      <div className={modStyl.a2}>
        <LineChart name="患者入组率" data={[
          {value: dataSource.withinSeven, name: '7天内'},
          {value: dataSource.sevenAndFourteen, name: '7天-14天'},
          {value: dataSource.overFourteen, name: '14天以上'},
        ]}/>
      </div>
    </div>
  )
}

export default BlockI